import React from 'react';
import { motion } from 'framer-motion';
import educationData from '../data/Education';
import { StickerGradCap } from './ui/stickers';
import { stampContainer, stampUp, viewportOnce } from '../lib/motion';

const accents = ['bg-sky', 'bg-sun', 'bg-bubble'];

const Education = () => {
  return (
    <section id="education" className="py-20 md:py-28 bg-paper dark:bg-noir">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.4 }}
          className="text-center mb-14"
        >
          <p className="font-display font-bold text-ink/60 dark:text-cream/60 mb-2">Where it started</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-ink dark:text-cream">
            Education &amp;{' '}
            <span className="inline-block -rotate-1 bg-sky px-3 brutal-border brutal-shadow-sm">
              Background
            </span>
          </h2>
        </motion.div>

        <motion.div
          variants={stampContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="border-t-2 border-b-2 border-ink dark:border-cream"
        >
          {educationData.map((edu, index) => (
            <motion.div
              key={edu.degree}
              variants={stampUp}
              className="flex flex-col sm:flex-row sm:items-center gap-4 py-6 border-b-2 border-ink dark:border-cream last:border-b-0"
            >
              <div className={`flex-shrink-0 flex h-11 w-11 items-center justify-center rounded-xl ${accents[index % accents.length]} brutal-border-thin`}>
                <StickerGradCap className="w-5 h-5 text-ink" />
              </div>

              <div className="flex-1">
                <h3 className="font-display text-lg font-extrabold text-ink dark:text-cream">{edu.degree}</h3>
                <p className="font-semibold text-ink/70 dark:text-cream/70">{edu.institution}</p>
                <p className="text-sm text-ink/60 dark:text-cream/60 mt-0.5">{edu.description}</p>
              </div>

              <div className="flex sm:flex-col sm:items-end gap-2 sm:gap-1 flex-shrink-0">
                <span className="px-3 py-1 text-xs font-bold rounded-full bg-mint text-ink brutal-border-thin whitespace-nowrap">
                  {edu.period}
                </span>
                {edu.grade && (
                  <span className="text-sm font-bold text-ink dark:text-cream">{edu.grade}</span>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Education;
